import { type PropsWithChildren } from 'react';

//#region Typings
/**
 * Accepted properties for the Select DisplayValue
 * @public
 */
export type SelectDisplayValueProps = PropsWithChildren<unknown>;
//#endregion

/**
 * `Select.DisplayValue` defines a custom display within the Trigger. A Select.DisplayValue component
 * is only valid within a Select.Trigger and accepts the following slots
 *
 * - Select.Prefix
 * - Freeform JSX content
 *
 * @example
 * ```tsx
 * <Select.DisplayValue>
 *   <Select.Prefix>
 *     <WhatsNewIcon />
 *   </Select.Prefix>
 *   Selected color:
 *   <Flex
 *     style={{ background: value }}
 *     width={'1rem'}
 *     height={'1rem'}
 *   />
 * </Select.DisplayValue>
 * ```
 * @public
 */
export function SelectDisplayValue(props: SelectDisplayValueProps): null {
  return null;
}
